import React from 'react';
import { Alert, Button } from 'react-bootstrap';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.error("Caught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-3">
          <Alert variant="danger">
            <Alert.Heading>Terjadi Kesalahan</Alert.Heading>
            <p>
              Terjadi kesalahan saat memuat halaman. Silakan refresh halaman atau kembali ke halaman utama.
            </p>
            <hr />
            <div className="d-flex justify-content-end">
              <Button 
                variant="outline-secondary" 
                onClick={() => window.location.href = '/'}
                className="me-2"
              >
                Ke Halaman Utama
              </Button>
              <Button 
                variant="primary" 
                onClick={() => window.location.reload()}
              >
                Refresh Halaman
              </Button>
            </div>
          </Alert>
          {process.env.NODE_ENV !== 'production' && (
            <div className="mt-3 p-3 border rounded bg-light">
              <h5>Detail Error (Development Mode):</h5>
              <p>{this.state.error && this.state.error.toString()}</p>
              <pre className="mt-3 p-2 bg-dark text-white rounded">
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;